import { render, staticRenderFns } from "./T04.vue?vue&type=template&id=db15fe0a&scoped=true"
import script from "./T04.vue?vue&type=script&lang=js"
export * from "./T04.vue?vue&type=script&lang=js"
import style0 from "./T04.vue?vue&type=style&index=0&id=db15fe0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db15fe0a",
  null
  
)

export default component.exports